<template>
  <div class="fixed inset-0 z-[9999] flex flex-row overflow-hidden bg-white">
    <!------------------ Sidebar Wrapper ------------------>
    <UpNavigationSidebarWrapper class="wrapper">
      <!------------------ Sidebar ------------------>
      <UpNavSideBar class="">
        <template #appLogo>
          <AppLogo />
        </template>
        <!------------------ Sidebar options ------------------>
        <template #sidebarOptions>
          <UpNavSidebarOptions
            v-for="{ id, isPrefix } in sidebarSkeletonOptions"
            :key="id"
            :is-prefix="isPrefix"
          >
            <template #options>
              <div
                class="sidebar-icon my-3 min-h-7 flex flex-col justify-center items-center gap-2"
              >
                <SkeletonBlock
                  custom-class="h-6 w-6 rounded-md"
                  animation-direction="horizontal"
                  bg-color="bg-primary-400"
                />
                <SkeletonBlock
                  custom-class="h-2 w-10 rounded-md"
                  animation-direction="horizontal"
                  bg-color="bg-primary-400"
                />
              </div>
            </template>
          </UpNavSidebarOptions>
        </template>
      </UpNavSideBar>
    </UpNavigationSidebarWrapper>
    <div class="flex flex-col w-full overflow-hidden bg-white min-h-screen">
      <!------------------ Navbar Wrapper ------------------>
      <UpNavigationNavbarWrapper>
        <!------------------ Topbar ------------------>
        <UpNavTopBar>
          <template #avatarIndicator>
            <SkeletonBlock
              custom-class="h-8 w-8 rounded-full"
              animation-direction="horizontal"
              bg-color="bg-info-100"
            ></SkeletonBlock>
          </template>
        </UpNavTopBar>
        <!------------------ Navbar ------------------>
        <UpNavBar />
      </UpNavigationNavbarWrapper>
      <!------------------ Spinner ------------------>
      <div class="mt-31 h-full flex-grow mx-6 my-4">
        <SpinnerLoader />
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
import AppLogo from "~/components/sidebar/AppLogo.vue";
import SpinnerLoader from "~/components/loaders/SpinnerLoader.vue";
import SkeletonBlock from "~/components/shared/skeleton-loader/SkeletonBlockV2.vue";

import UpNavigationSidebarWrapper from "~/components/sidebar/UpNavigationSidebar/UpNavigationSidebarWrapper.vue";
import UpNavSideBar from "~/components/sidebar/UpNavigationSidebar/UpNavSideBar.vue";
import UpNavigationNavbarWrapper from "~/components/header/UpNavigationNavbar/UpNavigationNavbarWrapper.vue";
import UpNavTopBar from "~/components/header/UpNavigationNavbar/UpNavTopBar.vue";
import UpNavBar from "~/components/header/UpNavigationNavbar/UpNavBar.vue";
import UpNavSidebarOptions from "~/components/sidebar/UpNavigationSidebar/UpNavSidebarOptions.vue";

const sidebarSkeletonOptions = Array.from({ length: 6 }, (_, i) => ({
  id: i + 1,
  isPrefix: i < 3,
}));
</script>
